<template>
  <form @submit.prevent="handleSubmit" class="px-4 sm:px-6 lg:px-9">
    <div class="flex flex-row flex-wrap items-center justify-between gap-2.5">
      <TitlePrimary :title="$t(isEdit ? 'admin.form.titles.edit' : 'admin.form.titles.new')" />
      <TitlePrimary
        class="px-20 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
        bgColor="bg-[#00000]"
        textColor="text-[#7CADB9]"
        :title="$t('admin.form.titles.subtitle')"
      />
    </div>

    <div v-if="loading" class="text-center p-4">{{ $t('admin.loading') }}</div>
    <div v-else-if="error" class="text-red-500 text-center p-4">{{ error }}</div>

    <template v-else>
      <!-- DATOS DEL ADMINISTRADOR -->
      <div class="py-8">
        <TitlePrimary
          :title="$t('admin.form.titles.adminData')"
          bg-color="bg-[#00000]"
          textColor="text-[#25B0D7]"
          class="border-none shadow-none"
        />

        <div class="client-form-columns">
          <div class="client-form-column">
            <InputPrimary
              v-model="form.nombreCuenta"
              :error="backendErrors.nombreCuenta || errors.nombreCuenta"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.accountName') + ':'"
              required
            />
            <InputPrimary
              v-model="form.cifCuenta"
              :error="backendErrors.cifCuenta || errors.cifCuenta"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.cif') + ':'"
            />
            <!-- <InputPrimary
              v-model="form.companyName"
              :error="backendErrors.companyName || errors.companyName"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.companyName') + ':'"
            /> -->
            <!-- <InputPrimary
              v-model="form.contactName"
              :error="backendErrors.contactName || errors.contactName"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.contactName') + ':'"
            /> -->
            <InputPrimary
              :modelValue="form.mobile"
              @update:modelValue="handleMobileUpdate"
              :error="backendErrors.mobile || errors.mobile"
              class="w-full"
              type="tel"
              :label="$t('admin.form.labels.mobile') + ':'"
            />
            <InputPrimary
              v-model="form.direccion"
              :error="backendErrors.direccion || errors.direccion"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.address') + ':'"
            />
            <InputPrimary
              v-model="form.codigoPostal"
              :error="backendErrors.codigoPostal || errors.codigoPostal"
              class="w-full"
              type="number"
              :label="$t('admin.form.labels.postalCode') + ':'"
            />
          </div>
          <div class="client-form-column">
            <InputPrimary
              v-model="form.municipio"
              :error="backendErrors.municipio || errors.municipio"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.municipality') + ':'"
            />
            <InputPrimary
              v-model="form.provincia"
              :error="backendErrors.provincia || errors.provincia"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.province') + ':'"
            />
            <div class="flex flex-col pb-2">
              <label class="cursor-pointer text-[#385660]">
                {{ $t('admin.form.labels.observations') }}:
              </label>
              <textarea
                class="text-[#7CADB9] border border-[#3A5762] rounded-xl h-29 p-2 resize-none w-full outline-none shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] duration-500 hover:scale-102 active:scale-100"
                v-model="form.observaciones">
              </textarea>
              <div v-if="backendErrors.observaciones || errors.observaciones" class="text-red-500 text-sm mt-1">
                {{ backendErrors.observaciones || errors.observaciones }}
              </div>
            </div>
            <SelectPrimary
              :error="backendErrors.tipoCuenta || errors.tipoCuenta"
              :options="tipoCuentaOptions"
              v-model="form.tipoCuenta"
              name="tipoCuenta"
              :label="$t('admin.form.labels.accountType') + ':'"
              required
              class="w-full"
            />
          </div>
          <div class="client-form-column">
            <!--
            <SelectPrimary
              :error="backendErrors.contratoSentDatos || errors.contratoSentDatos"
              :options="contratoSentOptions"
              v-model="form.contratoSentDatos"
              name="contratoDatos"
              class="py-2"
              :label="$t('admin.form.labels.dataContract') + ':'"
            />
            -->
            <!-- <SelectPrimary
              :error="backendErrors.passwordSent || errors.passwordSent"
              :options="passwordSentOptions"
              v-model="form.passwordSent"
              name="passwordSent"
              class="py-2"
              :label="$t('admin.form.labels.passwordSent') + ':'"
            /> -->
            <SelectPrimary
              :error="backendErrors.notificaciones || errors.notificaciones"
              :options="notificacionesOptions"
              v-model="form.notificaciones"
              name="notificaciones"
              class="py-2"
              :label="$t('admin.form.labels.notifications') + ':'"
            />
            <!-- Ver todas las incidencias (ADS-0122): Sí ve toda la cuenta; No, solo lo que gestiona o tiene asignado -->
            <SelectPrimary
              :error="backendErrors.sees_all_requests || errors.verTodasIncidencias"
              :options="notificacionesOptions"
              v-model="form.verTodasIncidencias"
              name="verTodasIncidencias"
              class="py-2"
              :label="$t('admin.form.labels.seesAllRequests') + ':'"
            />
            <SelectPrimary
              :error="backendErrors.maintenance || errors.maintenance"
              :options="mantenimientoOptions"
              v-model="form.maintenance"
              name="maintenance"
              class="py-2"
              :label="$t('admin.form.labels.maintenance') + ':'"
            />
            <div class="flex flex-col pb-2">
              <label class="cursor-pointer text-[#385660] pb-1">
                {{ $t('admin.form.labels.assignedCommercial') }}:
              </label>
              <div class="relative flex w-full items-center border border-[#3A5762] rounded-xl shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] bg-white">
                <input
                  v-model="form.comercial"
                  type="text"
                  readonly
                  :placeholder="$t('admin.form.placeholders.assignedCommercial')"
                  class="flex-1 px-3 py-2 text-[#7CADB9] outline-none bg-transparent cursor-not-allowed"
                />
                <div v-if="backendErrors.comercial || errors.comercial" class="absolute left-3 bottom-[-22px] text-red-500 text-sm">
                  {{ backendErrors.comercial || errors.comercial }}
                </div>
                <button
                  @click.prevent="openCommercialSearchModal"
                  type="button"
                  class="p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0 mr-2"
                  :title="$t('admin.form.labels.assignedCommercial')"
                >
                  <svg class="w-4 h-4 text-[#385660] hover:text-[#2AB4D9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="section-divider" />

      <!-- REPRESENTANTE LEGAL (ADS-0121): quien firma por la cuenta, distinto de la persona que accede -->
      <div class="py-8" data-testid="legal-rep">
        <TitlePrimary
          :title="$t('admin.form.titles.legalRep')"
          bg-color="bg-[#00000]"
          textColor="text-[#25B0D7]"
          class="border-none shadow-none"
        />

        <div class="client-form-columns">
          <InputPrimary
            v-model="form.repLegalNombre"
            :error="backendErrors.repLegalNombre || errors.repLegalNombre"
            class="w-full"
            type="text"
            :label="$t('admin.form.labels.legalRepName') + ':'"
          />
          <InputPrimary
            v-model="form.repLegalApellidos"
            :error="backendErrors.repLegalApellidos || errors.repLegalApellidos"
            class="w-full"
            type="text"
            :label="$t('admin.form.labels.legalRepSurname') + ':'"
          />
          <InputPrimary
            v-model="form.repLegalDocumento"
            :error="backendErrors.repLegalDocumento || errors.repLegalDocumento"
            class="w-full"
            type="text"
            :label="$t('admin.form.labels.legalRepDocument') + ':'"
          />
        </div>
      </div>

      <!-- USUARIO PRINCIPAL -->
      <div v-if="!isEdit" class="py-8">
        <TitlePrimary
          :title="$t('admin.form.titles.mainUser')"
          bg-color="bg-[#00000]"
          textColor="text-[#25B0D7]"
          class="border-none shadow-none"
        />

        <div class="client-form-columns">
          <div class="client-form-column">
            <InputPrimary
              :error="backendErrors.nombrePrincipal || errors.nombrePrincipal"
              v-model="form.nombrePrincipal"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.name') + ':'"
              required
            />
            <InputPrimary
              :error="backendErrors.apellidos || errors.apellidos"
              v-model="form.apellidos"
              class="w-full"
              type="text"
              :label="$t('admin.form.labels.surname') + ':'"
            />
          </div>
          <div class="client-form-column">
            <InputPrimary
              :error="backendErrors.correoElectronico || errors.correoElectronico"
              v-model="form.correoElectronico"
              class="w-full"
              type="email"
              :label="$t('admin.form.labels.email') + ':'"
              required
            />
            <InputPrimary
              :error="backendErrors.dni_nie || errors.dni_nie"
              v-model="form.dni_nie"
              class="w-full"
              type="text"
              :label="$t('requestDetailAdmin.labels.dni_nie') + ':'"
            />
          </div>
          <div class="client-form-column">
            <SelectPrimary
              :error="backendErrors.estadoUsuario || errors.estadoUsuario"
              :options="estadoUsuarioOptions"
              v-model="form.estadoUsuario"
              name="estadoUsuario"
              :label="$t('admin.form.labels.userStatus') + ':'"
              class="w-full"
            />
          </div>
        </div>
        <div v-if="!creationFinished || accessReady" class="initial-credentials-section">
          <InitialCredentials
            :password="accessReady ? savedCredentials.password : form.password"
            @update:password="form.password = $event"
            v-model:confirmation="form.verificarPassword"
            :email="accessReady ? savedCredentials.email : form.correoElectronico"
            :saved="accessReady"
            :password-error="backendErrors.password || errors.password"
            :confirmation-error="backendErrors.verificarPassword || errors.verificarPassword"
          />
        </div>
      </div>

      <hr v-if="!isEdit" class="border-[#b8b8b8] py-2" />

      <!-- FICHEROS A SUBIR -->
      <!-- <div v-if="!isEdit">
        <TitlePrimary
          :title="$t('admin.form.titles.files')"
          bg-color="bg-[#00000]"
          textColor="text-[#25B0D7]"
          class="border-none shadow-none"
        />

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <InputPrimary
              @change="handleFileChange($event, 'ficheroCif')"
              class="w-full"
              type="file"
              :label="$t('admin.form.labels.cif') + ':'"
            />
          </div>

          <div>
            <InputPrimary
              @change="handleFileChange($event, 'autorizacion')"
              class="w-full"
              type="file"
              :label="$t('admin.form.labels.dataContract') + ':'"
            />
          </div>
          <div>
            <InputPrimary
              @change="handleFileChange($event, 'multipunto')"
              class="w-full"
              type="file"
              :label="$t('admin.form.labels.maintenance') + ':'"
            />
          </div>
        </div>
      </div> -->

      <div v-if="accessReady" class="credentials-aligned flex flex-col gap-3 pb-6 text-sm text-[#385660] sm:flex-row sm:items-center sm:justify-between">
        <span>{{ $t('accessCredentials.ready') }}</span>
        <button type="button" @click="router.go(-1)" class="min-h-11 w-full shrink-0 rounded-lg border border-[#92b0bd] bg-white px-5 py-2.5 font-semibold hover:bg-[#eaf5f9] focus-visible:outline-3 focus-visible:outline-[#25b0d7] sm:w-auto">{{ $t('accessCredentials.done') }}</button>
      </div>
      <div v-else-if="creationFinished" class="credentials-aligned flex flex-col gap-3 pb-6 text-sm text-red-700 sm:flex-row sm:items-center sm:justify-between">
        <span>{{ $t('accessCredentials.notReady') }}</span>
        <button type="button" @click="router.go(-1)" class="min-h-11 w-full shrink-0 rounded-lg border border-[#92b0bd] bg-white px-5 py-2.5 font-semibold text-[#385660] hover:bg-[#eaf5f9] focus-visible:outline-3 focus-visible:outline-[#25b0d7] sm:w-auto">{{ $t('accessCredentials.done') }}</button>
      </div>
      <div v-else class="credentials-aligned flex justify-end pb-6">
        <div class="w-full sm:w-[220px]">
          <ButtonWhite
            :title="isEdit ? $t('admin.form.buttons.update') : $t('admin.form.buttons.save')"
            bgColor="bg-[#25B0D7]"
            textColor="text-[#fff]"
            hoverBgColor="hover:bg-[#5F99AE]"
            class="min-h-11 w-full justify-center"
            type="submit"
          />
        </div>
      </div>
    </template>

    <!-- Commercial Search Modal -->
    <div v-if="showCommercialSearchModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between p-6 border-b">
          <h3 class="text-lg font-semibold text-[#385660]">{{ $t('admin.form.modalCommercialSearch.title') }}</h3>
          <button @click="closeCommercialSearchModal" type="button" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Search Input -->
        <div class="p-6 border-b">
          <div class="relative">
            <input
              v-model="commercialSearchQuery"
              @input="searchCommercials"
              type="text"
              :placeholder="$t('admin.form.modalCommercialSearch.searchPlaceholder')"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent"
            />
            <div v-if="isSearchingCommercials" class="absolute right-3 top-1/2 transform -translate-y-1/2">
              <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]"></div>
            </div>
          </div>
        </div>

        <!-- Commercial List -->
        <div class="flex-1 overflow-y-auto p-6">
          <div v-if="isSearchingCommercials && !searchedCommercials.length" class="text-center py-8 text-gray-500">
            {{ $t('admin.form.modalCommercialSearch.searching') }}
          </div>
          <div v-else-if="!isSearchingCommercials && !searchedCommercials.length && commercialSearchQuery"
            class="text-center py-8 text-gray-500">
            {{ $t('admin.form.modalCommercialSearch.noResults') }}
          </div>
          <div v-else-if="!commercialSearchQuery" class="text-center py-8 text-gray-500">
            {{ $t('admin.form.modalCommercialSearch.startTyping') }}
          </div>
          <div v-else class="space-y-2">
            <button
              v-for="commercial in searchedCommercials"
              :key="commercial.id"
              @click="selectCommercial(commercial)"
              type="button"
              class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors"
            >
              <div class="font-medium text-[#385660]">{{ [commercial.name, commercial.surname].filter(Boolean).join(' ') }}</div>
              <div v-if="commercial.email" class="text-sm text-gray-500">{{ commercial.email }}</div>
            </button>
          </div>
        </div>

        <!-- Footer -->
        <div class="p-6 border-t flex justify-end space-x-3">
          <button
            @click="closeCommercialSearchModal"
            type="button"
            class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {{ $t('admin.form.modalCommercialSearch.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import InputPrimary from '@/components/inputs/input-primary.vue';
import { fetchAccountDetailWithKind } from '@/services/clientAccount';
import { accountToForm, accountChanges, legalRepPayload } from '@/services/clientAccountForm';
import TitlePrimary from '@/components/title/title-primary.vue';
import SelectPrimary from '@/components/select/SelectPrimary.vue';
import InitialCredentials from '@/components/access/InitialCredentials.vue';
import { reactive, watch, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { toast } from 'vue3-toastify';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const userId = route.query.id;
const action = route.query.action;
// En edición, la ficha puede ser de una cuenta cliente o de una persona.
const editKind = ref('user');
const loadedAccount = ref(null);
const isEdit = !!userId;
const isPasswordChange = action === 'password';

const loading = ref(false);
const error = ref(null);
const originalData = ref(null);
const accessReady = ref(false);
const creationFinished = ref(false);
const savedCredentials = ref(null);

const form = reactive({
  // Datos del administrador
  nombreCuenta: '',
  cifCuenta: '',
  companyName: '',
  contactName: '',
  mobile: '',
  direccion: '',
  codigoPostal: '',
  municipio: '',
  provincia: '',
  observaciones: '',
  tipoCuenta: '',
  contratoDatos: false,
  contratoSentDatos: false,
  passwordSent: false,
  // Por defecto recibe los correos del gestor; en la ficha de una cuenta se carga
  // el valor de su persona principal (ADS-0185).
  notificaciones: true,
  verTodasIncidencias: false,
  maintenance: false,
  comercial: '',
  father: null,
  dni_nie: '',
  iban: '',

  // Representante legal de la cuenta (ADS-0121)
  repLegalNombre: '',
  repLegalApellidos: '',
  repLegalDocumento: '',

  // Usuario principal
  nombrePrincipal: '',
  apellidos: '',
  correoElectronico: '',
  password: '',
  verificarPassword: '',
  estadoUsuario: 'active',

  // Ficheros
  ficheroCif: null,
  autorizacion: null,
  multipunto: null
});

// Commercial search modal variables
const showCommercialSearchModal = ref(false);
const commercialSearchQuery = ref('');
const searchedCommercials = ref([]);
const isSearchingCommercials = ref(false);
const searchTimeout = ref(null);


const tipoCuentaOptions = [
  { value: 'horizontal', label: 'Horizontal' },
  { value: 'vertical', label: 'Vertical' },
  { value: 'both', label: 'Horizontal y Vertical' },
];

const mantenimientoOptions = computed(() => [
  { value: true, label: t('admin.form.maintenanceOptions.with') },
  { value: false, label: t('admin.form.maintenanceOptions.without') },
]);

const notificacionesOptions = [
  { value: true, label: 'Si' },
  { value: false, label: 'No' },
];

const estadoUsuarioOptions = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
  { value: 'Eliminado', label: 'Eliminado' },
];

// Commercial search modal functions
const openCommercialSearchModal = () => {
  showCommercialSearchModal.value = true;
  commercialSearchQuery.value = '';
  searchedCommercials.value = [];
};

const closeCommercialSearchModal = () => {
  showCommercialSearchModal.value = false;
  commercialSearchQuery.value = '';
  searchedCommercials.value = [];
  isSearchingCommercials.value = false;
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
    searchTimeout.value = null;
  }
};

const searchCommercials = async () => {
  if (!commercialSearchQuery.value.trim()) {
    searchedCommercials.value = [];
    return;
  }

  // Clear previous timeout
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
  }

  // Set loading state
  isSearchingCommercials.value = true;

  // Debounce search
  searchTimeout.value = setTimeout(async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/user/commercial-candidates`,
        {
          params: {
            query: commercialSearchQuery.value.trim(),
          },
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );

      const commercialsPage = response.data?.value;
      searchedCommercials.value = Array.isArray(commercialsPage?.data) ? commercialsPage.data : [];
    } catch (error) {
      console.error("Error searching commercials:", error);
      searchedCommercials.value = [];
      toast.error("Error al buscar comerciales");
    } finally {
      isSearchingCommercials.value = false;
    }
  }, 300); // 300ms debounce
};

const selectCommercial = (commercial) => {
  form.comercial = `${commercial.name} ${commercial.surname || ''}`.trim();
  form.father = commercial.id;
  closeCommercialSearchModal();
  toast.success("Comercial seleccionado correctamente", {
    position: "top-right",
    autoClose: 2000,
  });
};

const uploadFile = async (file, file_Name, requestIdParam, fileTypeLabel) => {
  if (!file) return false;

  const request_id = requestIdParam || userId;
  const file_type = fileTypeLabel || file_Name;

  try {
    console.log('Iniciando subida de archivo:', {
      fileName: file.name,
      fileType: file.type,
      fileSize: file.size,
      file_Name: file_Name,
      file_type,
      request_id
    });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('file_name', file_Name);
    formData.append('file_path', file.name);
    formData.append('request_id', request_id);
    formData.append('file_type', file_type);

    // Log the actual FormData contents
    for (let pair of formData.entries()) {
      console.log('FormData entry:', pair[0] + ': ' + pair[1]);
    }

    const response = await axios.post(
      `${import.meta.env.VITE_API_URL}/admin/file/upload/${request_id}`,
      formData,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
          // let axios set the Content-Type boundary for multipart/form-data
        }
      }
    );

    console.log('Respuesta del servidor:', response.data);

    if (response.data?.value) {
      console.log('Archivo subido exitosamente:', file.name);
      return true;
    }
    return false;
  } catch (err) {
    console.error('Error al subir el archivo:', {
      error: err,
      fileName: file.name,
      file_type,
      request_id,
      response: err.response?.data,

    });
    return false;
  }
};

const requiredFields = ['nombreCuenta', 'nombrePrincipal', 'correoElectronico'];
// if (!isEdit) {
//   requiredFields.push('password');
// }
// El rol / tipo de cuenta es obligatorio según validación del backend
requiredFields.push('tipoCuenta');

const errors = reactive(
  requiredFields.reduce((acc, field) => {
    acc[field] = '';
    return acc;
  }, {})
);
errors.mobile = '';

const mobileHasInvalidCharacters = ref(false);

const normalizePhone = (value) => String(value || '').replace(/[^\d]/g, '');

const handleMobileUpdate = (value) => {
  mobileHasInvalidCharacters.value = /[^\d]/.test(String(value || ''));
  form.mobile = normalizePhone(value);

  if (!mobileHasInvalidCharacters.value) {
    errors.mobile = '';
    delete backendErrors.mobile;
  }
};

// Errores devueltos por el backend (mapeados a las propiedades locales)
const backendErrors = reactive({});

// Mapa de campos del backend -> campos del formulario local
const backendToLocalMap = {
  name: 'nombrePrincipal',
  surname: 'apellidos',
  mobile: 'mobile',
  has_notifications: 'notificaciones',
  sees_all_requests: 'verTodasIncidencias',
  legal_rep_name: 'repLegalNombre',
  legal_rep_surname: 'repLegalApellidos',
  legal_rep_document: 'repLegalDocumento',
  email: 'correoElectronico',
  password: 'password',
  dni_nie: 'dni_nie',
  iban: 'iban',
  role: 'tipoCuenta',
  username: 'nombreCuenta',
  status: 'estadoUsuario',
  cif: 'cifCuenta',
  company_name: 'companyName',
  contact_name: 'contactName',
  password_sent: 'passwordSent',
  contract_sent: 'contratoSentDatos',
  address: 'direccion',
  observations: 'observaciones',
  postal_code: 'codigoPostal',
  city: 'municipio',
  state: 'provincia',
  maintenance: 'maintenance',
  commercial: 'comercial',
  father: 'father'
};

requiredFields.forEach(field => {
  watch(() => form[field], (val) => {
    if (val) errors[field] = '';
  });
});

// Limpiar mensajes del backend cuando el usuario modifica los campos correspondientes
watch(form, (newVal) => {
  Object.keys(backendErrors).forEach((key) => {
    if (newVal[key] !== undefined) {
      delete backendErrors[key];
    }
  });
}, { deep: true });

const validateForm = () => {
  let isValid = true;

  // Al editar una cuenta no se muestran los datos del usuario principal (viven
  // en su propia ficha), así que solo se exige lo que el formulario enseña.
  const fieldsToCheck = editKind.value === 'account'
    ? requiredFields.filter((field) => ['nombreCuenta', 'tipoCuenta'].includes(field))
    : requiredFields;

  fieldsToCheck.forEach(field => {
    errors[field] = '';
    if (!form[field]) {
      errors[field] = 'Este campo es obligatorio';
      isValid = false;
    }
  });

  errors.mobile = '';
  if (mobileHasInvalidCharacters.value || (form.mobile && !/^\d{8,15}$/.test(form.mobile))) {
    errors.mobile = 'El teléfono debe tener entre 8 y 15 dígitos numéricos';
    isValid = false;
  }

  if (!isEdit) {
    errors.password = form.password.length < 8 ? t('accessCredentials.minLength') : '';
    errors.verificarPassword = form.password !== form.verificarPassword ? t('accessCredentials.mismatch') : '';
    if (errors.password || errors.verificarPassword) isValid = false;
  } else if (isPasswordChange && form.password !== form.verificarPassword) {
    toast.error(t('accessCredentials.mismatch'), { position: 'top-right' });
    isValid = false;
  }

  if (!isValid) {
    toast.error('Por favor, complete todos los campos obligatorios.', { position: 'top-right' });
  }

  return isValid;
};

const fetchUserData = async () => {
  if (!isEdit) return;

  loading.value = true;
  try {
    console.log('Iniciando carga de datos del usuario');
    // La ficha de un cliente se abre con el id de su cuenta, que no vive en
    // `users`: se resuelve primero como cuenta y, si no lo es, como persona.
    const detail = await fetchAccountDetailWithKind(userId);
    editKind.value = detail.kind;

    if (detail.kind === 'account' && detail.value) {
      loadedAccount.value = detail.value;
      Object.assign(form, accountToForm(detail.value));
      loading.value = false;

      return;
    }

    const response = { data: { value: detail.value } };

    console.log('Respuesta del servidor:', response.data);

    if (response.data?.value) {
      const userData = response.data.value;
      console.log('Datos del usuario recibidos:', userData);

      // Guardar los datos originales
      originalData.value = {
        name: userData.name || '',
        surname: userData.surname || '',
        mobile: userData.mobile || '',
        has_notifications: Boolean(userData.has_notifications),
        sees_all_requests: Boolean(userData.sees_all_requests),
        email: userData.email || '',
        password: userData.password || '',
        dni_nie: userData.dni_nie || '',
        iban: userData.iban || '',
        role: userData.roles?.[0]?.name || '',
        username: userData.username || '',
        status: userData.status || '',
        cif: userData.cif || '',
        company_name: userData.company_name || '',
        contact_name: userData.contact_name || '',
        address: userData.address || '',
        observations: userData.observations || '',
        postal_code: userData.postal_code || '',
        city: userData.city || '',
        state: userData.state || '',
        maintenance: Boolean(userData.maintenance),
        commercial: userData.commercial || '',
        father: userData.father || null,
        contract_data: Boolean(userData.contract_data),
        contract_sent: Boolean(userData.contract_sent),
        password_sent: Boolean(userData.password_sent)
      };

      console.log('Datos originales guardados:', originalData.value);

      // Actualizar formulario
      form.nombrePrincipal = userData.name || '';
      form.apellidos = userData.surname || '';
      form.correoElectronico = userData.email || '';
      form.mobile = userData.mobile || '';
      form.nombreCuenta = userData.username || '';
      form.cifCuenta = userData.cif || '';
      form.companyName = userData.company_name || '';
      form.contactName = userData.contact_name || '';
      form.direccion = userData.address || '';
      form.codigoPostal = userData.postal_code || '';
      form.municipio = userData.city || '';
      form.provincia = userData.state || '';
      form.observaciones = userData.observations || '';
      form.tipoCuenta = userData.roles?.[0]?.name || '';
      form.contratoDatos = Boolean(userData.contract_data);
      form.notificaciones = Boolean(userData.has_notifications);
      form.verTodasIncidencias = Boolean(userData.sees_all_requests);
      form.contratoSentDatos = Boolean(userData.contract_sent);
      form.passwordSent = Boolean(userData.password_sent);
      form.estadoUsuario = userData.status || '';
      form.password = userData.password || '';
      form.maintenance = Boolean(userData.maintenance);
      form.comercial = userData.commercial || '';
      form.father = userData.father || null;

      console.log('Formulario actualizado con datos del usuario');
    } else {
      console.error('No se recibieron datos del usuario');
      error.value = 'No se pudieron cargar los datos del usuario';
    }
  } catch (err) {
    console.error('Error fetching user data:', err);
    error.value = 'Error al cargar los datos del usuario';
    toast.error('Error al cargar los datos del usuario', {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } finally {
    loading.value = false;
  }
};

const getChangedFields = () => {
  if (!originalData.value) {
    console.log('No hay datos originales para comparar');
    return null;
  }

  const changedFields = {};
  const newData = {
    name: form.nombrePrincipal,
    surname: form.apellidos,
    mobile: normalizePhone(form.mobile),
    has_notifications: form.notificaciones,
    sees_all_requests: form.verTodasIncidencias,
    email: form.correoElectronico,
    dni_nie: form.dni_nie,
    iban: form.iban,
    role: form.tipoCuenta,
    username: form.nombreCuenta,
    status: form.estadoUsuario,
    cif: form.cifCuenta,
    company_name: form.companyName,
    contact_name: form.contactName,
    address: form.direccion,
    observations: form.observaciones,
    postal_code: form.codigoPostal,
    city: form.municipio,
    state: form.provincia,
    maintenance: form.maintenance,
    commercial: form.comercial,
    father: form.father,
    contract_data: form.contratoDatos,
    contract_sent: form.contratoSentDatos,
    password_sent: form.passwordSent
  };

  console.log('=== INICIO DE COMPARACIÓN DE CAMPOS ===');
  console.log('Datos originales del usuario:', JSON.stringify(originalData.value, null, 2));
  console.log('Nuevos datos del formulario:', JSON.stringify(newData, null, 2));

  // Lista de campos booleanos
  const booleanFields = ['has_notifications', 'sees_all_requests', 'maintenance', 'contract_data', 'contract_sent', 'password_sent'];

  // Lista de campos numéricos
  const numericFields = ['father'];

  // Comparar cada campo
  Object.keys(newData).forEach(key => {
    const originalValue = originalData.value[key];
    const newValue = newData[key];

    // Para campos booleanos
    if (booleanFields.includes(key)) {
      const normalizedOriginal = Boolean(originalValue);
      const normalizedNew = Boolean(newValue);

      console.log(`Comparando campo booleano ${key}:`, {
        original: originalValue,
        normalizedOriginal,
        new: newValue,
        normalizedNew
      });

      if (normalizedOriginal !== normalizedNew) {
        changedFields[key] = normalizedNew;
        console.log(`✅ Campo booleano modificado: ${key}`, {
          valorAnterior: normalizedOriginal,
          nuevoValor: normalizedNew
        });
      }
    }
    // Para campos numéricos
    else if (numericFields.includes(key)) {
      const normalizedOriginal = originalValue ? Number(originalValue) : null;
      const normalizedNew = newValue ? Number(newValue) : null;

      console.log(`Comparando campo numérico ${key}:`, {
        original: originalValue,
        normalizedOriginal,
        new: newValue,
        normalizedNew
      });

      if (normalizedOriginal !== normalizedNew) {
        changedFields[key] = normalizedNew;
        console.log(`🔢 Campo numérico modificado: ${key}`, {
          valorAnterior: normalizedOriginal,
          nuevoValor: normalizedNew
        });
      }
    }
    // Para campos de texto
    else if (typeof newValue === 'string') {
      if (originalValue !== newValue) {
        changedFields[key] = newValue;
        console.log(`📝 Campo de texto modificado: ${key}`, {
          valorAnterior: originalValue,
          nuevoValor: newValue
        });
      }
    }
    // Para otros tipos de campos
    else {
      if (originalValue !== newValue) {
        changedFields[key] = newValue;
        console.log(`🔄 Campo modificado: ${key}`, {
          valorAnterior: originalValue,
          nuevoValor: newValue
        });
      }
    }
  });

  // Solo incluir la contraseña si se ha modificado y coincide con la verificación
  if (form.password && form.password === form.verificarPassword && form.password !== originalData.value.password) {
    changedFields.password = form.password;
  }

  return Object.keys(changedFields).length > 0 ? changedFields : null;
};

const handleSubmit = async () => {
  if (creationFinished.value) return;
  console.log('Submit iniciado');
  if (!validateForm()) {
    console.log('Validación fallida');
    return;
  }

  try {
    console.log('Preparando envío del formulario');
    let endpoint;
    let method;
    let payload;

    if (isEdit) {
      console.log('Modo edición');
      // First handle file uploads if any files were selected
      const fileUploadPromises = [];
      if (form.ficheroCif) {
        console.log('Subiendo archivo CIF:', form.ficheroCif.name);
        fileUploadPromises.push(uploadFile(form.ficheroCif, 'ficheroCif', undefined, 'NIF_CIF'));
      }
      if (form.autorizacion) {
        console.log('Subiendo archivo de autorización:', form.autorizacion.name);
        fileUploadPromises.push(uploadFile(form.autorizacion, 'autorizacion', undefined, 'Autorizacion'));
      }
      if (form.multipunto) {
        console.log('Subiendo archivo multipunto:', form.multipunto.name);
        fileUploadPromises.push(uploadFile(form.multipunto, 'multipunto', undefined, 'Multipunto'));
      }

      // Wait for all file uploads to complete
      const uploadResults = await Promise.all(fileUploadPromises);
      const hasFileUploads = uploadResults.some(result => result === true);
      console.log('Resultados de subida de archivos:', uploadResults);

      // Get changed fields for user update
      const changedFields = getChangedFields();

      // If there are no changes in the form but files were uploaded successfully
      if (!changedFields && hasFileUploads) {
        console.log('Solo se subieron archivos, sin cambios en el formulario');
        toast.success('Archivos subidos exitosamente', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          router.go(-1);
        }, 1500);
        return;
      }

      // Una cuenta se guarda en su propio endpoint: su id no existe en `users`.
      if (editKind.value === 'account') {
        const accountPayload = accountChanges(form, loadedAccount.value);
        if (Object.keys(accountPayload).length === 0) {
          toast.info('No se detectaron cambios para actualizar', { position: 'top-right', autoClose: 2000 });

          return;
        }

        await axios.put(
          `${import.meta.env.VITE_API_URL}/client-account/update/${userId}`,
          accountPayload,
          { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' } }
        );
        toast.success('Cliente actualizado exitosamente', { position: 'top-right', autoClose: 2000 });
        setTimeout(() => { router.go(-1); }, 1500);

        return;
      }

      // If there are changes in the form, proceed with user update
      if (changedFields) {
        console.log('=== PREPARANDO ACTUALIZACIÓN ===');
        console.log('Endpoint:', `${import.meta.env.VITE_API_URL}/user/update/${userId}`);
        console.log('Método: PUT');

        endpoint = `${import.meta.env.VITE_API_URL}/user/update/${userId}`;
        method = 'put';
        payload = changedFields;

        const response = await axios[method](
          endpoint,
          payload,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('=== RESPUESTA DEL SERVIDOR ===');
        console.log('Respuesta de actualización:', JSON.stringify(response.data, null, 2));

        const successMessage = hasFileUploads
          ? 'Usuario actualizado y archivos subidos exitosamente'
          : 'Usuario actualizado exitosamente';

        toast.success(successMessage, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          router.go(-1);
        }, 1500);
      } else {
        console.log('No hay cambios para actualizar');
        toast.info('No se detectaron cambios para actualizar', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      console.log('Modo creación de nuevo usuario');
      // Código para crear nuevo usuario
      endpoint = `${import.meta.env.VITE_API_URL}/admin/create`;
      method = 'post';
      payload = {
        name: form.nombrePrincipal,
        surname: form.apellidos,
        mobile: normalizePhone(form.mobile),
        has_notifications: form.notificaciones,
        sees_all_requests: form.verTodasIncidencias,
        email: form.correoElectronico,
        password: form.password,
        password_confirmation: form.verificarPassword,
        dni_nie: form.dni_nie,
        iban: form.iban,
        role: form.tipoCuenta,
        username: form.nombreCuenta,
        status: form.estadoUsuario,
        cif: form.cifCuenta,
        company_name: form.companyName,
        contact_name: form.contactName,
        contract_sent: form.contratoSentDatos,
        address: form.direccion,
        observations: form.observaciones,
        postal_code: form.codigoPostal,
        city: form.municipio,
        state: form.provincia,
        maintenance: form.maintenance,
        commercial: form.comercial,
        father: form.father,
        contract_data: form.contratoDatos,
        ...legalRepPayload(form)
      };

      const createResponse = await axios[method](
        endpoint,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('Usuario creado exitosamente:', createResponse.data);

      // Obtener id del usuario recién creado (ajusta según la estructura de la API)
      const newUserId = createResponse.data?.value?.id || createResponse.data?.id || null;

      // Subir ficheros si se seleccionaron
      const fileUploadPromises = [];
      if (form.ficheroCif) fileUploadPromises.push(uploadFile(form.ficheroCif, 'ficheroCif', newUserId, 'cif'));
      if (form.autorizacion) fileUploadPromises.push(uploadFile(form.autorizacion, 'autorizacion', newUserId, 'autorizacion'));
      if (form.multipunto) fileUploadPromises.push(uploadFile(form.multipunto, 'multipunto', newUserId, 'multipunto'));

      const uploadResults = fileUploadPromises.length ? await Promise.all(fileUploadPromises) : [];
      const hasFileUploads = uploadResults.some(result => result === true);
      console.log('Resultados de subida de archivos (creación):', uploadResults);

      const successMessage = hasFileUploads ? 'Usuario creado y archivos subidos exitosamente' : 'Usuario creado exitosamente';

      toast.success(successMessage, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      creationFinished.value = true;
      accessReady.value = createResponse.data?.access_ready === true;
      if (accessReady.value) {
        savedCredentials.value = { email: payload.email, password: payload.password };
      } else {
        toast.error(t('accessCredentials.notReady'));
      }
    }
  } catch (err) {
    // Axios incluye el cuerpo de la petición en el error; no registrar la contraseña.
    console.error('Error saving user');
    const errorMessage = isEdit
      ? 'Error al actualizar el usuario'
      : 'Error al crear el usuario';

    // Si hay errores de validación desde el backend (Laravel), mapearlos
    const serverErrors = err?.response?.data?.errors;
    if (serverErrors && typeof serverErrors === 'object') {
      // Limpiar errores previos
      Object.keys(backendErrors).forEach(k => delete backendErrors[k]);

      Object.keys(serverErrors).forEach((key) => {
        const messages = serverErrors[key];
        const msg = Array.isArray(messages) ? messages[0] : messages;
        const localField = backendToLocalMap[key] || key;
        backendErrors[localField] = msg;
      });

      toast.error('Errores de validación en el formulario', {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

onMounted(() => {
  if (isEdit) {
    fetchUserData();
  }
});
</script>

<style scoped>
.credentials-aligned {
  box-sizing: border-box;
  width: 100%;
}

.section-divider {
  margin: 0;
  border: 0;
  border-top: 1px solid #d5e5eb;
}

.client-form-columns {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 24px;
}

.client-form-columns > * {
  flex: 1 1 calc((100% - 48px) / 3);
  min-width: 0;
}

.client-form-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.initial-credentials-section {
  margin-top: 28px;
}

.client-form-columns :deep(.container) {
  margin-block: 0;
}

.client-form-columns :deep(.container > p:empty) {
  display: none;
}

.client-form-columns :deep(select) {
  width: 100%;
  max-width: none;
}

@media (max-width: 1199px) {
  .client-form-columns > * {
    flex-basis: calc((100% - 24px) / 2);
  }
}

@media (max-width: 699px) {
  .client-form-columns > * {
    flex-basis: 100%;
  }
}
</style>
